export const isPasskeySupported = () =>
  window.isSecureContext && typeof window.PublicKeyCredential !== 'undefined';

export const hasPlatformAuthenticator = async () =>
  isPasskeySupported() &&
  (await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().catch(() => false));
